import type { ExperimentSection } from 'definitions';
import type { Experiment, UserSummary } from 'types';

type SectionAuthorParams = { experiment: Pick<Experiment, 'sectionAuthors'>; section: ExperimentSection };

/**
 * Who first wrote a section, or null when nobody is on record.
 *
 * Null is the normal case for anything written before authors were recorded, and for an
 * experiment loaded without `sectionAuthors` (the library list does not carry it). The
 * badge is shown only when the section has content as well, which the caller knows and
 * this does not: the debrief's content lives in the report, not on the experiment.
 */
export const sectionAuthor = ({ experiment, section }: SectionAuthorParams): UserSummary | null =>
  experiment.sectionAuthors?.find((row) => row.section === section)?.user ?? null;
